import React, { useRef } from "react";
import { useFormContext } from 'react-hook-form'
import SelectInput from "../SelectInput/SelectInput";
import styles from './MessengersItem.module.scss'
import cn from 'classnames'
import { Country, Lang } from "../../../types/common-types";
import { State } from '../../../state-actions-reducers'
import { messengersLinksOptions } from "../../../content/messengersLinks";
import TextInput from "../TextInput/TextInput";
import PhoneInput from "../PhoneInput/PhoneInput";
import accountForm from "../../../content/account-form";
import DeleteButton from "../../../shared/Buttons/DeleteButton";

interface Props {
    lang: Lang;
    index: number
    allCitizenships: Country[]
    disabled: boolean
    deleteHandler: () => void
}

export default function MessengersItem({ lang, index, allCitizenships, disabled, deleteHandler }: Props) {
    const { watch, setValue, formState: { errors } } = useFormContext<State>()
    const state = watch()

    const countriesRef = useRef(
        allCitizenships?.reduce(
            (object, country) => ({
                ...object,
                [country.alpha2 as any]: (country as any)[lang],
            }),
            {}
        )
    )
    const countries = countriesRef.current
    const filterOptions = messengersLinksOptions.filter((f) => !state.messengers.find((e) => e.type === f.value))
    return <div className={cn('row', styles.messenger_row)}>
        <div className={'col-4 col-xs-12'}>
            <SelectInput
                testName={`messengersType-${index}`}
                testErrorName={`error-messengersType-${index}`}
                noOptionsMessage={
                    accountForm.messengerLinksDescription.placeholder
                }
                options={filterOptions}
                disabled={disabled}
                lang={lang}
                content={accountForm.messengerLinksDescription}
                onChange={(e: any) => {
                    const updated = index < state.messengers.length
                        ? state.messengers.map((item, i) => {
                            return (index === i) ? {
                                type: e,
                                description: e,
                                link: state.messengers[index]?.link ?? "",
                            } : item
                        }) : state.messengers.concat({
                            type: e,
                            description: e,
                            link: state.messengers[index]?.link ?? "",
                        })
                    setValue('messengers', updated as any, { shouldDirty: true })
                }}
                valid={!errors.messengersType}
                value={state?.messengers[index]?.type}
                optionValue={{
                    label: state?.messengers[index]?.type,
                    value: state?.messengers[index]?.type
                }}
            />
        </div>
        <div className={'col-4 col-xs-12'}>
            {state?.messengers[index]?.type === 'Telegram' || state?.messengers[index]?.type === 'Max' ||
                (state.whatsappCheck && state?.messengers[index]?.type === 'WhatsApp' && state?.messengers[index]?.isCheck) ?
                <TextInput
                    testName={`messengersLink${index}`}
                    testErrorName={`error-messengersLink${index}`}
                    lang={lang}
                    content={state?.messengers[index]?.type === 'Telegram' || state?.messengers[index]?.type === 'Max' ? accountForm.telegramLink : accountForm.mobilePhoneNumber}
                    onChange={(e) => {
                        let telegram = e.replace(/[^A-Za-z0-9_]/gi, '')
                        if (/^\d/.test(telegram)) {
                            telegram = telegram.slice(1);
                        }
                        const updated = index < state.messengers.length
                            ? state.messengers.map((item, i) => {
                                return (index === i) ? {
                                    type: state.messengers[index]?.type,
                                    description: state.messengers[index]?.description,
                                    link: telegram,
                                } : item
                            }) : state.messengers.concat({
                                type: state.messengers[index]?.type,
                                description: state.messengers[index]?.description,
                                link: telegram
                            })
                        setValue('messengers', updated as any, { shouldDirty: true })
                    }}
                    value={
                        (state.telegramCheck && state?.messengers[index]?.type === 'Telegram') && state?.messengers[index]?.isCheck ||
                            (state.whatsappCheck && state?.messengers[index]?.type === 'WhatsApp' && state?.messengers[index]?.isCheck) ?
                            state?.messengers[index]?.link :
                            `@${state?.messengers[index]?.link}`
                    }
                    valid={!errors[`messengersLink${index}`]}
                    disabled={disabled || !state?.messengers[index]?.type}
                />
                :
                <PhoneInput
                    testName={`messengersLink${index}`}
                    testErrorName={`error-messengersLink${index}`}
                    label={accountForm.mobilePhoneNumber.label[lang]}
                    lang={lang}
                    numbers={
                        state.messengers.length === 0
                            ? ['']
                            : [state.messengers[index]?.link]
                    }
                    setNumbers={(e) => {
                        const updated = index < state.messengers.length
                            ? state.messengers.map((item, i) => {
                                return (index === i) ? {
                                    type: state.messengers[index]?.type,
                                    description: state.messengers[index]?.description,
                                    link: e[0],
                                } : item
                            }) : state.messengers.concat({
                                type: state.messengers[index]?.type,
                                description: state.messengers[index]?.description,
                                link: e[0]
                            })
                        setValue('messengers', updated as any, { shouldDirty: true })
                    }}
                    invalidText={accountForm?.mobilePhoneNumber?.invalidText?.[lang]}
                    countries={countries}
                    required
                    firstlocked={state.Confirm_phone_ok}
                    valid={!errors[`messengersLink${index}`]}
                    disabled={disabled || !state?.messengers[index]?.type}
                />}
            {!state?.messengers[index]?.isCheck && !(state?.messengers.length <= 1 && index === 0) ? (
                <>
                    <DeleteButton
                        testName="deleteMessenger"
                        className={styles.deleteBtn}
                        onClick={deleteHandler}
                    />
                    <button
                        data-test-id="deleteMessenger"
                        className={styles.messengerMobileDeleteButton}
                        onClick={() => {
                            setValue('messengers', state.messengers.filter((e, i) => i !== index) as any, { shouldDirty: true })
                        }}
                    >
                        Удалить
                    </button>
                </>
            ) : null}
        </div>
    </div>
}
